// extracted by mini-css-extract-plugin
module.exports = {"Container":"Spinner_Container__1uFaG","Spinner":"Spinner_Spinner__2klvp","big":"Spinner_big__HP2j-","spin-fast":"Spinner_spin-fast__1XAS7","small":"Spinner_small__1CbjD"};